"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.saveDocumentUUID = exports.getDocumentUUID = void 0;
var getDocumentUUID = function (storageName, document_id) {
    var serializedState = localStorage.getItem(storageName);
    if (serializedState === null) {
        return null;
    }
    var state = {};
    try {
        state = JSON.parse(serializedState);
    }
    catch (_a) {
        return null;
    }
    var uuid = state[document_id];
    if (uuid === undefined) {
        return null;
    }
    return uuid;
};
exports.getDocumentUUID = getDocumentUUID;
var saveDocumentUUID = function (storageName, document_id, uuid) {
    var _a;
    try {
        var serializedState = String(localStorage.getItem(storageName));
        var storage = {};
        try {
            storage = JSON.parse(serializedState);
        }
        catch (_b) {
            // ignore error
        }
        var newState = __assign(__assign({}, storage), (_a = {}, _a[document_id] = uuid, _a));
        localStorage.setItem(storageName, JSON.stringify(newState));
    }
    catch (e) {
        // ignore errors
        console.error(e);
    }
};
exports.saveDocumentUUID = saveDocumentUUID;
